import { useState, useEffect } from 'react'

const FormikURL = ({ className, name, value, setFieldValue }) => {
  const [URLValue, setURLValue] = useState(value)

  useEffect(()=>{
    if (!value){
    setFieldValue(name, '')
    setURLValue('')
  }

  // XXX Fix this in the future
  // eslint-disable-next-line
  },[])

  const handleURLChange = e => {
    const URLTextBoxValue = e.target.value
    setURLValue(URLTextBoxValue)
    setFieldValue(name, URLTextBoxValue)
  }

  return (
    <input
      className={className}
      type='url'
      value={URLValue}
      onChange={handleURLChange}
    />
  )
}

export default FormikURL
